import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { JsonLd, organizationSchema } from '@/components/base/JsonLd';
import { testimonials, faqItems } from '@/mocks/news';

const aboutWebPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '关于我们 - 黑料在线',
  description: '黑料在线 — 网红八卦资讯聚合平台，了解我们的品牌故事、用户口碑与联系方式。',
  url: 'http://baiducc.cn/about',
};

const testimonialImageUrls = [
  'https://readdy.ai/api/search-image?query=Dramatic%20portrait%20silhouette%20with%20warm%20golden%20rim%20lighting%2C%20mysterious%20anonymous%20figure%2C%20editorial%20portrait%20photography%2C%20dark%20atmosphere%2C%20cinematic%20mood%2C%20soft%20backlighting%2C%20professional%20composition%2C%20deep%20warm%20tones&width=400&height=560&seq=about-testimonial-01&orientation=portrait',
  'https://readdy.ai/api/search-image?query=Dramatic%20portrait%20silhouette%20with%20warm%20golden%20rim%20lighting%2C%20mysterious%20anonymous%20figure%2C%20editorial%20portrait%20photography%2C%20dark%20atmosphere%2C%20cinematic%20mood%2C%20soft%20backlighting%2C%20professional%20composition%2C%20deep%20warm%20tones&width=400&height=560&seq=about-testimonial-02&orientation=portrait',
];

export default function AboutPage() {
  return (
    <>
      <JsonLd data={organizationSchema} />
      <JsonLd data={aboutWebPageSchema} />
      <Navbar />
      <main className="pt-16">
        <div className="px-4 md:px-6 py-4">
          <div className="max-w-7xl mx-auto">
            <nav aria-label="面包屑导航">
              <ol className="flex items-center gap-2 text-xs text-foreground-500">
                <li><Link to="/" className="hover:text-foreground-900 transition-colors">首页</Link></li>
                <li><i className="ri-arrow-right-s-line text-xs"></i></li>
                <li className="text-foreground-900 font-medium">关于我们</li>
              </ol>
            </nav>
          </div>
        </div>

        <section className="px-4 md:px-6 py-10 md:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-5 gap-8 md:gap-12">
              <div className="md:col-span-2">
                <span className="text-xs font-medium text-foreground-500 border border-background-300 px-3 py-1 rounded-full mb-3 inline-block">
                  关于我们
                </span>
                <h1 className="text-2xl md:text-4xl font-black font-heading text-foreground-950 mt-3 mb-2">
                  黑料在线
                </h1>
                <p className="text-base md:text-lg font-heading text-secondary-500 mb-6">
                  做最有态度的吃瓜平台
                </p>
                <div className="text-sm text-foreground-600 leading-relaxed space-y-4">
                  <p>
                    黑料在线成立于2024年，是一家专注于网红八卦、娱乐圈资讯的聚合平台。我们致力于为读者提供最新、最全、最真实的爆料内容，让每一位吃瓜群众都能第一时间掌握热门资讯。
                  </p>
                  <p>
                    我们的编辑团队由多位资深娱乐记者和自媒体人组成，拥有丰富的行业经验和广泛的人脉资源。我们坚持真实、客观的报道原则，每一条爆料都经过多方核实后才进行发布。
                  </p>
                  <p>
                    在信息爆炸的时代，黑料在线不仅是一个资讯平台，更是一个有态度的内容社区。我们关注行业生态，追踪热点事件，用专业的视角为读者解读每一个八卦背后的故事。
                  </p>
                </div>
                <Link
                  to="/category/wanghong-baoliao"
                  className="inline-flex items-center gap-1 text-sm text-accent-600 font-medium hover:underline mt-6"
                >
                  浏览最新爆料
                  <i className="ri-arrow-right-line text-xs"></i>
                </Link>
              </div>

              <div className="md:col-span-3 relative">
                <div className="absolute top-0 right-0 flex gap-6 z-10">
                  <div className="text-right">
                    <div className="text-3xl md:text-5xl font-black font-heading text-foreground-950">5000+</div>
                    <div className="text-xs md:text-sm text-foreground-500">累计爆料数</div>
                  </div>
                  <div className="text-right">
                    <div className="text-3xl md:text-5xl font-black font-heading text-foreground-950">2000+</div>
                    <div className="text-xs md:text-sm text-foreground-500">覆盖网红数</div>
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3 md:gap-4 mt-10 md:mt-14">
                  <div className="rounded-xl overflow-hidden aspect-[3/4] translate-y-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Professional%20newsroom%20with%20dramatic%20warm%20lighting%2C%20editorial%20photography%20style%2C%20dark%20amber%20and%20charcoal%20tones%2C%20journalists%20working%20atmosphere%2C%20typewriter%20on%20wooden%20desk%2C%20mysterious%20mood%2C%20professional%20composition&width=400&height=560&seq=about-brand-01&orientation=portrait"
                      alt="黑料在线编辑部工作场景"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="rounded-xl overflow-hidden aspect-[3/4] -translate-y-4">
                    <img
                      src="https://readdy.ai/api/search-image?query=Media%20team%20collaboration%20workspace%20with%20dramatic%20lighting%2C%20editorial%20photography%2C%20warm%20golden%20and%20dark%20tones%2C%20news%20production%20atmosphere%2C%20professional%20studio%2C%20mysterious%20mood%2C%20cinematic%20composition&width=400&height=560&seq=about-brand-02&orientation=portrait"
                      alt="黑料在线团队协作"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-20 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
                用户口碑
              </h2>
              <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
                听听我们的用户怎么说
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {testimonials.map((t, idx) => (
                <div key={t.id} className="relative rounded-2xl bg-foreground-900 overflow-hidden">
                  <div className="grid grid-cols-5">
                    <div className="col-span-2 relative min-h-[160px] -mb-1 -mr-6 z-10">
                      <img
                        src={testimonialImageUrls[idx]}
                        alt="用户"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                    <div className="col-span-3 flex flex-col justify-center p-5 md:p-6">
                      <div className="text-accent-400 text-3xl md:text-4xl font-serif mb-2">&ldquo;</div>
                      <blockquote className="text-xs md:text-sm text-background-50 leading-relaxed mb-3 line-clamp-4">
                        {t.quote}
                      </blockquote>
                      <div className="text-xs text-foreground-400">
                        <span className="font-semibold text-background-50">{t.author}</span>
                        <span className="mx-2">·</span>
                        <span>{t.role}</span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-20">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 rounded-2xl overflow-hidden">
              <div className="relative min-h-[280px] md:min-h-[380px] bg-amber-100/50">
                <img
                  src="https://readdy.ai/api/search-image?query=Journalism%20concept%20with%20dramatic%20warm%20atmospheric%20lighting%2C%20typewriter%20and%20papers%20on%20dark%20wooden%20desk%2C%20editorial%20photography%2C%20golden%20amber%20tones%2C%20investigative%20mood%2C%20professional%20composition%2C%20newsroom%20atmosphere&width=800&height=600&seq=about-cta-bg&orientation=landscape"
                  alt="商务合作"
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 left-4">
                  <span className="text-xs font-medium text-background-50 bg-foreground-900/60 px-3 py-1 rounded-full">
                    商务合作
                  </span>
                </div>
                <div className="absolute bottom-6 left-6">
                  <h3 className="text-2xl md:text-4xl font-black font-heading text-background-50 leading-tight">
                    加入我们
                    <br />
                    一起爆料
                  </h3>
                </div>
              </div>

              <div className="bg-background-50 flex flex-col items-center justify-center text-center p-8 md:p-12">
                <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950 mb-4">
                  商务合作与投稿
                </h2>
                <p className="text-sm md:text-base text-foreground-600 mb-4 leading-relaxed max-w-md">
                  如果你有猛料想要曝光，或者希望与我们进行商务合作，欢迎通过以下方式联系我们。
                </p>
                <div className="space-y-3 text-sm text-foreground-700 mb-6">
                  <div className="flex items-center gap-2">
                    <i className="ri-mail-line text-accent-500"></i>
                    <span>投稿邮箱：hello@baiducc.cn</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-mail-line text-accent-500"></i>
                    <span>商务合作：hello@baiducc.cn</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-phone-line text-accent-500"></i>
                    <span>联系电话：400-888-8888</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-map-pin-line text-accent-500"></i>
                    <span>公司地址：北京市朝阳区某某大厦12层</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 md:px-6 py-10 md:py-20 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-8">
              常见问题
            </h2>
            <div className="space-y-3">
              {faqItems.map((faq, idx) => (
                <details key={idx} className="group bg-background-50 rounded-xl">
                  <summary className="flex items-center justify-between p-4 cursor-pointer text-sm font-medium text-foreground-900 list-none">
                    {faq.question}
                    <i className="ri-add-line group-open:hidden text-foreground-500"></i>
                    <i className="ri-subtract-line hidden group-open:block text-foreground-500"></i>
                  </summary>
                  <div className="px-4 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}